<template>
  <div class="pt-3 d-flex justify-center">
    <div class="_temp_list" v-if="person && !loading">
      <title-page title="User Configuration" />
      <v-card class="rounded_max mb-5" elevation="1">
        <div class="banner d-flex justify-space-between">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="white"
                v-bind="attrs"
                v-on="on"
                @click="$router.go(-1)"
                icon
                ><v-icon>mdi-reply</v-icon></v-btn
              >
            </template>
            <span>Back</span>
          </v-tooltip>
          <div class="boba1"></div>
          <div class="boba2"></div>
          <div class="boba3"></div>
          <div class="boba4"></div>
        </div>
        <div class="d-flex justify-center">
          <img
            :src="person.profile_picture ? person.profile_picture : ava"
            class="dp"
            alt=""
          />
        </div>
        <h3 class="text-capitalize text-center">{{ person.name }}</h3>
        <div class="d-flex justify-center mt-2">
          <div class="cursor" @click="makeMentor" v-if="!person.is_mentor">
            <v-icon>mdi-checkbox-blank-outline </v-icon>
            Make Mentor
          </div>
          <div class="cursor" @click="makeMentor" v-if="person.is_mentor">
            <v-icon>mdi-checkbox-marked </v-icon>
            Mentor
          </div>
        </div>
        <div class="d-flex justify-center">
          <form-update-alumni :person="person" />
        </div>
      </v-card>
      <v-card
        v-if="
          permissions.includes('UPCM') ||
          role == 'VENDOR' ||
          role == 'SUPERADMIN'
        "
        class="rounded_max mb-5 d-flex align-center px-3"
        elevation="1"
      >
        <div class="full_w my-4 d-flex align-center flex-column">
          <div class="_85_w d-flex align-center flex-column">
            <div
              class="rounded-xl my-4"
              style="width: 100%; height: 0.5vh; background-color: red"
            ></div>
            <div class="_94_w mx-5 px-5 d-flex flex-column">
              <h3 style="color: red">Danger Zone</h3>
              <div
                class="mt-2 pa-2 rounded-lg"
                style="border: 1px solid rgba(254, 4, 4, 0.24)"
              >
                <h4>Delete this Account</h4>
                <p class="ma-0 pa-0">
                  Once you deleted this account, there is no going back. User
                  will be permanently deleted. Are you sure?
                </p>
              </div>
              <div class="d-flex justify-end mt-4">
                <v-btn
                  class="rounded-lg"
                  color="red"
                  @click="deleteData"
                  depressed
                  dark
                  ><v-icon>mdi-delete</v-icon> Delete Account</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </div>
    <div class="d-flex justfiy-center" v-if="loading">
      <loading-lg />
    </div>
    <div class="pa-3">
      <dialog-small
        :d_small="d_small"
        @refetch="$router.go(-1)"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import titlePage from "../../../components/atom/titlePage.vue";
import { mapState } from "vuex";
import FormUpdateAlumni from "./formUpdateAlumni.vue";
import DialogSmall from "../../dialog/dialogSmall.vue";
export default {
  components: { titlePage, FormUpdateAlumni, DialogSmall },
  computed: {
    ...mapState({
      ava: (state) => state.ava_lg,
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  name: "manageaAlumni",
  data() {
    return {
      person: null,
      loading: true,
      dataSet: null,
      type: "SCHOLAR",
      tempPath: "",
      hintDelete: "",
      d_user: false,
      permissionData: null,
      permissionUserVendor: "",
      permissionTF: [],
      d_small: false,
      inventory: "",
      d_type: "",
      d_title: "",
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    makeMentor() {
      // this.loading = true;
      let permission = null;
      if (!this.person.is_mentor) {
        permission = ["MENTOR"];
      } else {
        permission = [];
      }
      let body = {
        id: this.person.user_id,
        permissions: permission,
      };
      let data = {
        path: `permission/assign`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then(() => {
          this.fetchData();
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    deleteData() {
      this.d_type = "d_businessAcument";
      this.d_title = "Delete Data";
      this.d_small = true;
      this.inventory = {
        path: "manage/graduate/delete",
        id: this.$route.params.id,
      };
    },
    fetchData() {
      this.loading = true;

      let data = {
        path: `manage/graduate?filter[user_id]=${this.$route.params.id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          let extend = data.data[0].extend_alumni;
          this.person = data.data[0];
          if (extend) {
            this.person["s1_major"] = extend.s1_major ?? "";
            this.person["s1_university_id"] = extend.s1_university_id ?? "";
            this.person["s2_major"] = extend.s2_major ?? "";
            this.person["s2_university_id"] = extend.s2_university_id ?? "";
          }
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.banner {
  background: #006341;
  width: 100%;
  height: 150px;
  overflow: hidden;
}
.bannerAccess {
  background: #006341;
  width: 100%;
  height: 60px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bannerDelete {
  background: red;
  width: 100%;
  height: 60px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dp {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  z-index: 2;
  margin-top: -75px;
}
/* .negative_top {
  margin-top: -75px;
} */

.divider {
  height: 1px !important;
  background-color: #006341;
}
</style>
